import { render, staticRenderFns } from "./DownloadPage.vue?vue&type=template&id=a1f54bbe&scoped=true"
import script from "./DownloadPage.vue?vue&type=script&lang=js"
export * from "./DownloadPage.vue?vue&type=script&lang=js"
import style0 from "./DownloadPage.vue?vue&type=style&index=0&id=a1f54bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f54bbe",
  null
  
)

export default component.exports